import { TAudioDevice } from '../actions/audio-device.actions';

export interface IAudioDeviceState {
  audioDevices: string[];
}

export const defaultAudioDeviceState = {
  audioDevices: [],
};

export const audioDeviceReducer = (
  state: IAudioDeviceState = defaultAudioDeviceState,
  action: any
): IAudioDeviceState => {
  switch (action.type) {
    case TAudioDevice.GET_AUDIO_DEVICES_SUCCESS:
      return { ...state, audioDevices: action.payload };
  }
  return state;
};
